<div class="text-center mx-auto pb-5">

  <h5>Impressum</h5>
  <h6>Angaben gemäß §5 Telemediengesetz</h6>

  Vertreten durch: Antonio Cengija<br><br>
  <h6>iLogistix GmbH</h6>
  Autenbachstr. 12-16<br>
  71711 Steinheim / Deutschland<br><br>
  Telefon: +49 7144 89723-29<br>
  E-Mail: <a href="mailto:info@i-logistix.de">info&commat;i-logistix.de</a><br><br>
  <a routerLink="/datenschutz">Datenschutzerklärung</a><br><br>
  <p class="fw-bold mb-2"> Registereintrag:</p>
  Eingetragen im Handelsregister<br>
  Registergericht: Amtsgericht Stuttgart<br>
  Registernummer: HRB 781001<br><br>
  <p class="fw-bold mb-2">Umsatzsteuer-ID:</p>
  Umsatzsteuer-Identifikationsnummer nach §27a Umsatzsteuergesetz:<br>
  DE346941994
</div>
